<!--  -->
<template>
  <div class="detail">
    <multi></multi>
    <div class="main">
      <div class="content">
        <p class="title1">{{ detailData.originaltitle }}</p>
        <p class="title2">
          {{ detailData.translationtitle }}
          <span
            @click="toyiyu"
            v-if="detailData.translationcontent"
          >
            <i class="el-icon-question"></i> 翻译不准确？试试人工翻译
          </span>
        </p>
        <p class="tagGroup">
          <span class="country" v-if="detailData.advcountry != null">
            {{ detailData.advcountry
            }}
            <img
              v-if="detailData.countryname"
              :src="
                `http://182.61.21.235/images/${detailData.countryname}`
              "
              alt
            />
          </span>
          <span v-else>暂无地区信息</span>
          <el-tag v-if="detailData.industrylabel != null">
            {{
            detailData.industrylabel
            }}
          </el-tag>
          <el-tag v-if="detailData.industrylabelt != null">
            {{
            detailData.industrylabelt
            }}
          </el-tag>
          <!-- >0f4d72 -->
        </p>
        <p class="info">
          <span>{{ detailData.sourcename }}</span>
          <span>发布日期：{{ detailData.advreleasetime }}</span>
        </p>
        <el-tabs v-model="activeName" @tab-click="tabClick">
          <el-tab-pane label="资讯原文" name="1">
            <p
              v-html="detailData.originalcontent"
              style="white-space: pre-line;line-height:50px;color:#666;text-indent:28px"
            ></p>
          </el-tab-pane>
          <el-tab-pane label="AI翻译" name="2" v-if="detailData.translationcontent">
            <p
              v-html="detailData.translationcontent"
              style="white-space: pre-line;line-height:50px;color:#666;text-indent:28px"
            ></p>
          </el-tab-pane>
        </el-tabs>
        <div class="btn">
          <button class="yy" @click="toyiyu" v-if="detailData.translationcontent">翻译不准确？点击开始人工精准翻译</button>
        </div>
      </div>
      <relevant :info="info" :title="detailData"></relevant>
    </div>
    <login :visible.sync="dialogFormVisible" @result="result"></login>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import relevant from '../components/relevant.vue'
import { API_1, Global } from '@/conf/api'
import tool from '../tool/tool'
import login from '../components/login.vue'
import multi from '../components/header.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'info',
  components: { multi, relevant, login },
  data() {
    //这里存放数据
    return {
      activeName: '1',
      info: {}, //右侧资讯列表
      detailData: {}, //详情页数据
      dialogFormVisible: false, //登录框显示or隐藏
      fullscreenLoading: false, //loading
      id: this.$route.query.id,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route() {
      this.id = this.$route.query.id //获取传来的参数
      this.getInfo() //路由变化时就重新执行这个方法 更新传来的参数
    },
  },
  //方法集合
  methods: {
    result(val) {
      location.reload()
      // this.uid = tool.getCookie('user')
      // let token = tool.getCookie('qxchuhai')
    },
    tabClick(tab, event) {},
    toyiyu() {
      window.location.href = 'http://www.inewyee.com'
    },
    getInfo() {
      //信息
      let params = {
        advid: this.id,
      }
      this.axios
        .get(API_1 + Global.infoDetail, { params: params })
        .then((res) => {
          this.detailData = res.data.data[0]
          this.info = res.data.data[1]
        })
        .catch((res) => {})
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.divider {
  //分割线
  width: 100%;
  height: 40px;
  border-bottom: 1px dotted #fff;
  margin-bottom: 40px;
}
.detail {
  background: url('../assets/listbg.jpg') repeat-y center center;
  .main {
    width: 1200px;
    min-width: 1200px;
    margin: 20px auto;
    .content {
      display: inline-block;
      text-align: left;
      background: #fff;
      border-radius: 4px;
      padding: 20px 40px 20px;
      width: 860px;
      box-sizing: border-box;
      .el-tabs {
        /deep/.el-tabs__item {
          color: #999;
        }
        /deep/.is-active {
          color: #0f4d72;
        }
        /deep/.el-tabs__active-bar {
          background: #0f4d72;
        }
      }
      .btn {
        margin-top: 20px;
        text-align: center;
        p {
          color: #999;
          font-size: 14px;
        }
        .yy {
          background-image: url('../assets/yy.png');
          background-position: 35px center;
          background-size: 25px 25px;
          background-repeat: no-repeat;
          background-color: #d32c3c;
          color: #fff;
          width: 320px;
          height: 40px;
          border-radius: 4px;
          padding-left: 30px;
          font-size: 14px;
          margin: 0 20px;
          &:hover {
            background-color: #e34151;
          }
        }
      }
      .title1,
      .title2 {
        width: 800px;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #333;
      }
      .title2 {
        font-weight: inherit;
        margin-bottom: 20px;
        font-size: 16px;
        span {
          color: #0f4d72;
          text-decoration: underline;
          cursor: pointer;
          margin-left: 10px;
          &:hover {
            color: #178cd1;
          }
        }
      }
      .info {
        font-size: 14px;
        color: #999;
        margin-bottom: 20px;
        span {
          margin-right: 50px;
        }
      }
      .tagGroup {
        font-size: 14px;
        margin-bottom: 20px;
        .el-tag {
          margin-left: 20px;
          color: #0f4d72;
          background: rgba(15, 77, 114, 0.1);
          height: 24px;
          line-height: 21px;
        }
        .country {
          img {
            width: 34px;
            height: 20px;
            margin-left: 10px;
            border: 1px solid #dcdcdc;
          }
        }
        .kbrq {
          font-size: 14px;
          color: #0f4d72;
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
